import { Bell } from 'lucide-react';
import * as React from 'react';
import { cn } from '@/helpers/utils';
import { useUnreadCount } from '@/hooks/data/notifications';

export type NotificationBellProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  panelOpen?: boolean;
};

export const NotificationBell = React.forwardRef<HTMLButtonElement, NotificationBellProps>(
  ({ className, panelOpen, ...props }, ref) => {
    const { data } = useUnreadCount();
    const count = data?.count ?? 0;
    const ariaLabel = count > 0 ? `Notifications, ${count} unread` : 'Notifications';

    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          'relative inline-flex h-10 w-10 cursor-pointer items-center justify-center rounded-md text-foreground hover:bg-accent hover:text-accent-foreground',
          className,
        )}
        aria-label={ariaLabel}
        aria-haspopup="dialog"
        aria-expanded={panelOpen ?? false}
        {...props}
      >
        <Bell className="h-5 w-5" aria-hidden />
        {count > 0 ? (
          <span
            className="absolute right-1 top-1 h-2.5 w-2.5 rounded-full bg-destructive"
            aria-hidden
          />
        ) : null}
      </button>
    );
  },
);

NotificationBell.displayName = 'NotificationBell';
